import differenceInCalendarWeeksReal from 'date-fns/differenceInCalendarWeeks';
import endOfWeekReal from 'date-fns/endOfWeek';
import formatReal from 'date-fns/format';
import getWeekReal from 'date-fns/getWeek';
import isSameWeekReal from 'date-fns/isSameWeek';
import parseReal from 'date-fns/parse';
import setDayReal from 'date-fns/setDay';
import startOfWeekReal from 'date-fns/startOfWeek';

const DEFAULT_DATE_FNS_OPTIONS: {
	weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
} = {
	weekStartsOn: 1, // Start on monday. Week is monday -> sunday.
};

// Wrap a date-fns method with default options param
// eslint-disable-next-line no-unused-vars
const mixinDefaultOptions = <p extends (...args: any[]) => any>(fn: p) => {
	return function (this: any, ...theArgs: any[]) {
		const lastIndex = fn.length - 1;
		if (fn.length === theArgs.length) {
			theArgs[lastIndex] = {
				...DEFAULT_DATE_FNS_OPTIONS,
				...theArgs[lastIndex],
			};
		} else {
			theArgs[lastIndex] = DEFAULT_DATE_FNS_OPTIONS;
		}
		return fn.apply(this, theArgs);
	} as p;
};

export const differenceInCalendarWeeks: typeof differenceInCalendarWeeksReal = mixinDefaultOptions(
	differenceInCalendarWeeksReal,
);
export const endOfWeek: typeof endOfWeekReal = mixinDefaultOptions(endOfWeekReal);
export const format: typeof formatReal = mixinDefaultOptions(formatReal);
export const getWeek: typeof getWeekReal = mixinDefaultOptions(getWeekReal);
export const isSameWeek: typeof isSameWeekReal = mixinDefaultOptions(isSameWeekReal);
export const parse: typeof parseReal = mixinDefaultOptions(parseReal);
export const setDay: typeof setDayReal = mixinDefaultOptions(setDayReal);
export const startOfWeek: typeof startOfWeekReal = mixinDefaultOptions(startOfWeekReal);
